import type { ReactNode } from 'react'
import SmoothScroll from '@/components/effects/SmoothScroll'
import { AuroraBackground } from '@/components/ui/aurora-background'
import { GhostBackdrop } from '@/components/ui/ghost-backdrop'
import { Navbar } from './Navbar'
import { Footer } from './Footer'

/** Shared chrome for every route: backdrop, navbar, footer, smooth scroll. */
export function SiteShell({ children }: { children: ReactNode }) {
  return (
    <SmoothScroll>
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[100] focus:rounded-full focus:bg-white focus:px-4 focus:py-2 focus:text-sm focus:text-ink"
      >
        Skip to content
      </a>
      <AuroraBackground />
      <GhostBackdrop />
      <Navbar />
      <main id="main" className="relative">
        {children}
      </main>
      <Footer />
    </SmoothScroll>
  )
}
